import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageAccountActivateComponent } from './page-account-activate.component';

const routes: Routes = [{ path: '', component: PageAccountActivateComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageAccountActivateRoutingModule { }
